// extracted by mini-css-extract-plugin
export var parcelRow = "_t0-0";